import { useNavigate } from "react-router-dom";
import { useEvents } from "../../actions/homeActions";

export default () => {
  const formatEventDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: "numeric", month: "short", day: "2-digit" };
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };
  
  const navigate = useNavigate();
  const { data: Events, isLoading, isError, error } = useEvents();
  
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1, // With variableWidth, this doesn't matter much
    slidesToScroll: 1,
    variableWidth: true, // Enable fixed width slides
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 9999, // Apply to all screen sizes
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
        }
      }
    ]
  };

  const handleEvents = (id) => {
    navigate(`/event-details/${id}`);
  };

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading events: {error.message}</p>
      </div>
    );
  }
  
  return { formatEventDate, Events, isLoading, sliderSettings, handleEvents };
};